import React from 'react';

const PopupSubmitInput = ({value = 'Submit', styleOverride}) => (
    <input className={` ${styleOverride} btn btn-popupPrimary flex items-center self-start mr-3`} type="submit" value={value} />
);

export default PopupSubmitInput;